exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".talentTitle[data-v-6922b5b4]{display:inline-block;width:300px}.err-msg[data-v-6922b5b4]{padding-left:20px;color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6922b5b4&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/talent/newTalent.vue
// module id = 564
// module chunks = 0